<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" style="min-height: 500px;">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <!--      Modal panel-->
      <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <!--        Modal header-->
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="closeModal"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <span class="sr-only">Close</span>
            <!-- Heroicon name: x -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!--        Modal Body-->
        <div class="sm:flex sm:items-start">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
              {{ transEdit('register-availability') }}
            </h3>
<!--          <div class="col-md-12">-->

<!--            <h5>{{ transEdit('register-availability') }}</h5>-->
<!--            <hr>-->
<!--            <br>-->
<!--            <div class="h6 font-weight-bold"></div>-->
<!--            <div class="text-muted"></div>-->

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-4">
                <label class="block text-sm font-medium text-gray-700">
                  {{ transEdit('startdate') }}:
                </label>
                <div class="mt-1">
                  <datetime v-model="startDate"
                            input-class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"></datetime>
                </div>
              </div>

              <div class="sm:col-span-4">
                <label class="block text-sm font-medium text-gray-700">
                  {{ transEdit('enddate') }}:
                </label>
                <div class="mt-1">
                <datetime v-model="endDate"
                          input-class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"></datetime>
                </div>
              </div>
            </div>
<!--          </div>-->


          <template v-if="startDate < endDate">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-4">
              <label>{{ transEdit('weekdays') }}</label>
              <multiselect
                  :options="weekDays"
                  v-model="selectedWeekDays"
                  :close-on-select="false"
                  track-by="index"
                  label="name"
                  placeholder="Välj veckodag"
                  multiple>
                <option v-for="(weekDay, dayIndex) in weekDays" :value="dayIndex">{{ weekDay }}</option>
              </multiselect>
            </div>
            </div>
          </template>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-4">
                <label class="block text-sm font-medium text-gray-700">
                  {{ transEdit('start') }}:
                </label>
                <div class="mt-1">
                  <datetime v-model="startTime" type="time"
                            input-class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"></datetime>
                </div>
              </div>

              <div class="sm:col-span-4">
                <label class="block text-sm font-medium text-gray-700">
                  {{ transEdit('end') }}:
                </label>
                <div class="mt-1">
                  <datetime v-model="endTime"
                            input-class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                            type="time"></datetime>
                </div>
              </div>
            </div>

<!--          <div class="mt-3 form-group max-w-xs">-->
<!--            <label>{{ transEdit('start') }}: </label>-->
<!--            <datetime v-model="startTime" type="time"-->
<!--                      input-class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"></datetime>-->
<!--          </div>-->

<!--          <div class="mt-3 form-group max-w-xs">-->
<!--            <label>{{ transEdit('end') }}: </label>-->
<!--            <datetime v-model="endTime"-->
<!--                      input-class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"-->
<!--                      type="time"></datetime>-->
<!--          </div>-->
          <div v-if="! conflicts">
            <br><br>
          </div>

          <div class="pt-2" v-if="conflicts">
            <div>
              <span class="text-lg text-red-400">{{ transEdit('scheduled_appointment_conflicts') }}</span>
            </div>
            <div v-for="(conflictDate, dateKey) in conflicts">
              <div><strong>{{ dateKey }}:</strong></div>
              <div v-if="conflictDate.schedules.length > 0">
                <span>{{ transEdit('scheduled_appointments') }}</span>

                <ul>
                  <li v-for="schedule in conflictDate.schedules">
                    <span>{{ getTimespanNoDate(schedule.start, schedule.end) }}</span>
                  </li>
                </ul>

              </div>

              <div v-if="conflictDate.availabilities.length > 0">
                <span>{{ transEdit('registered-availabilities') }}</span>

                <ul>
                  <li v-for="availability in conflictDate.availabilities">
                    <span>{{ getTimespanNoDate(availability.start, availability.end) }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>


<!--          <hr class="mt-12">-->
<!--          <div class="my-2">-->
<!--            <button class="rounded bg-tlmblue2 px-8 py-1 text-white" @click="storeAvailability"><i class="fa fa-plus"></i>-->
<!--              {{ transEdit('register-availability') }}-->
<!--            </button>-->
<!--            <button class="rounded bg-red-300 text-white px-8 py-1" @click="closeModal"><i class="fa fa-ban"></i>-->
<!--              {{ transEdit('cancel') }}-->
<!--            </button>-->
<!--          </div>-->
            <div class="pt-5">
              <div class="flex justify-end">
                <button type="button" @click="closeModal"
                        class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  {{ transEdit('cancel') }}
                </button>
                <button type="submit" @click="storeAvailability"
                        class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  {{ transEdit('register-availability') }}
                </button>
              </div>
            </div>
        </div>

      </div>

      </div>

    </div>
  </div>

</template>

<script>
import Vue from 'vue';

export default {
  name: "AddAvailabilityModal",
  props: ["date", "route_store"],
  data() {
    let weekDaysArray = [
      {
        index: 0,
        name: 'Måndag',
      },
      {
        index: 1,
        name: 'Tisdag',
      },
      {
        index: 2,
        name: 'Onsdag',
      },
      {
        index: 3,
        name: 'Torsdag',
      },
      {
        index: 4,
        name: 'Fredag',
      },
      {
        index: 5,
        name: 'Lördag',
      },
      {
        index: 6,
        name: 'Söndag',
      },
    ];

    return {
      conflicts: null,
      weekDays: weekDaysArray,
      selectedWeekDays: [],
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
    }
  },
  computed: {
    selectedWeekDaysAsIntegerArray() {
      let returnArray = [];
      for (let obj of this.selectedWeekDays) {
        returnArray.push(obj.index);
      }
      return returnArray;
    }
  },
  methods: {
    updateStartTime(e) {
    },
    getDateTime(dateString) {
      return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm')
    },
    getTime(dateString) {
      return moment(dateString).format('HH:mm')
    },
    getTimespanSameDate(start, end) {
      let _start = moment(start);
      let _end = moment(end);
      return _start.format('YYYY-MM-DD') + ', ' + _start.format('HH:mm') + ' - ' + _end.format('HH:mm');
    },
    getTimespanNoDate(start, end) {
      let _start = moment(start);
      let _end = moment(end);
      return _start.format('HH:mm') + ' - ' + _end.format('HH:mm');
    },
    closeModal() {
      this.$emit('close');
    },
    storeAvailability() {
      let self = this;
      let startDate = $("#availability-start-date").val();
      let endDate = $("#availability-end-date").val();
      let startTime = $("#availability-start").val();
      let endTime = $("#availability-end").val();

      axios.post(this.route_store, {
        'start_date': this.startDate,
        'end_date': this.endDate,
        'week_days': this.selectedWeekDaysAsIntegerArray,
        'start_time': this.startTime,
        'end_time': this.endTime,
      })
          .then((response) => {
            if (response.data.error) {
              self.conflicts = response.data.data;
            } else {
              Vue.toasted.success(self.transEdit('availability-registered'));
              self.conflicts = null;
              self.closeModal();
            }
          })
          .catch(function (error) {
          });
    },
  },
  mounted() {
    this.startDate = new Date(this.date.format('YYYY-MM-DD').toString()).toISOString();
    this.endDate = new Date(this.date.format('YYYY-MM-DD').toString()).toISOString();
    let startTime = (new Date(this.date.format('YYYY-MM-DD').toString())).setHours(7);
    let endTime = (new Date(this.date.format('YYYY-MM-DD').toString())).setHours(18);
    this.startTime = new Date(startTime).toISOString();
    this.endTime = new Date(endTime).toISOString();
  },
}
</script>

<style scoped>
.tlm-form-input {
  @apply w-full bg-transparent border-r-0 border-l-0 border-t-0 pl-0 pb-0 text-black mb-0;
  outline: none;
  height: 50px;
  border: none !important;
}

.tlm-form-input:focus ~ .tlm-form-input-underline:after {
  transform: scaleX(1);
}

.tlm-form-input:focus + .tlm-form-label, .tlm-form-input:not(:placeholder-shown) + .tlm-form-label, tlm-form-input.used {
  @apply text-black;
  color: #fff;
  transform: translate(0, -65px) scale(0.75);
  transform-origin: top left;
}

.tlm-form-input-main {
  font-size: 1.25rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.tlm-form-input-box {
  @apply relative;
  position: relative;
}

.tlm-form-label {
  @apply absolute pointer-events-none;
  position: absolute;
  pointer-events: none;
  transform-origin: top left;
  transform: translate(0, -40px) scale(1);
  transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
}

.tlm-form-label-focus {
  @apply text-white;
  color: #fff;
  transform: translate(0, -65px) scale(0.75);
  transform-origin: top left;
}

.tlm-form-input-underline {
  border-bottom: 1px solid #718096;;
}
</style>
